// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_b5-0";
export var optionCard = "_b5-1";